import { useLayoutEffect, useRef } from "react";
import type { RuleGraphFlowNodeData } from "./ruleGraphNodeData/RuleGraphFlowNodeData";

export function useNodeMeasurement<T extends HTMLElement>(
  id: string,
  measure: RuleGraphFlowNodeData["onMeasure"]
) {
  const rootRef = useRef<T | null>(null);
  const measureRef = useRef(measure);
  const enabled = measure !== undefined;
  useLayoutEffect(() => {
    measureRef.current = measure;
  }, [measure]);
  useLayoutEffect(() => {
    const element = rootRef.current;
    if (!element || !enabled) {
      return;
    }
    let frame = 0;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const width = element.offsetWidth,
          height = element.offsetHeight;
        if (width > 0 && height > 0) {
          measureRef.current?.(id, { width, height });
        }
      });
    });
    observer.observe(element);
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [enabled, id]);
  return rootRef;
}
